module.exports = __webpack_public_path__ + "img/外摆位.dac362e7.png";